import {
  useInfiniteQuery,
  type InfiniteData,
  type QueryKey,
} from '@tanstack/react-query';
import {
  DEFAULT_PAGE_INDEX,
  DEFAULT_PAGE_SIZE,
} from 'constants/appConstants';
import { GlobalCatalogueService } from 'services/GlobalCatalogueServices';

export const useFetchGCollection = <T>(
  collectionKey: string,
  gOrgId: string | null,
  queryKey: unknown[],
  pageSize: number = DEFAULT_PAGE_SIZE
) => {
  return useInfiniteQuery<T[], Error, InfiniteData<T[]>, QueryKey, number>({
    queryKey: [...queryKey, gOrgId] as QueryKey,
    queryFn: ({ pageParam, signal }) =>
      GlobalCatalogueService.FetchGRegularCollectionData(
        collectionKey,
        gOrgId!,
        pageSize,
        pageParam,
        undefined,
        signal
      ) as Promise<T[]>,
    initialPageParam: DEFAULT_PAGE_INDEX,
    getNextPageParam: (lastPage, _allPages, lastPageParam) =>
      lastPage.length >= pageSize ? lastPageParam + 1 : undefined,
    enabled: !!gOrgId,
    staleTime: 1000 * 60 * 5,
  });
};
